import { Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, throwError } from 'rxjs';
import { switchMap, catchError, finalize, filter, take } from 'rxjs/operators';
import { AuthenticationService } from '../services';
import { AppConfig } from '@awp/core/config';
var AuthRequestInterceptor = /** @class */ (function () {
    function AuthRequestInterceptor(authService, injector) {
        this.authService = authService;
        this.injector = injector;
        this.isRefreshingToken = false;
        this.tokenSubject = new BehaviorSubject(null);
    }
    Object.defineProperty(AuthRequestInterceptor.prototype, "appConfig", {
        get: function () {
            if (this._appConfig == null) {
                this._appConfig = this.injector.get(AppConfig);
            }
            return this._appConfig;
        },
        enumerable: true,
        configurable: true
    });
    AuthRequestInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        if (request.url.startsWith('./assets')) {
            return next.handle(request);
        }
        if (!request.url.startsWith(this.appConfig.API_BASE_URL)
            || request.url.includes('/Application/Authenticate')
            || request.url.includes('/Application/ReAuthenticate')) {
            return next.handle(request);
        }
        return next.handle(this.addTokenToRequest(request, this.authService.token))
            .pipe(catchError(function (err) {
            if (err instanceof HttpErrorResponse) {
                switch (err.status) {
                    case 401:
                        return _this.handle401Error(request, next);
                    case 400:
                        return throwError(err);
                    default:
                        return throwError(err);
                }
            }
            else {
                return throwError(err);
            }
        }));
    };
    AuthRequestInterceptor.prototype.addTokenToRequest = function (request, token) {
        return request.clone({ setHeaders: { Authorization: "Bearer " + token } });
    };
    AuthRequestInterceptor.prototype.handle401Error = function (request, next) {
        var _this = this;
        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;
            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);
            return this.authService.refresh()
                .pipe(switchMap(function (entity) {
                if (entity != null) {
                    _this.tokenSubject.next(entity.properties.accessToken);
                    return next.handle(_this.addTokenToRequest(request, entity.properties.accessToken));
                }
            }), catchError(function (err) {
                return throwError(err);
            }), finalize(function () {
                _this.isRefreshingToken = false;
            }));
        }
        else {
            return this.tokenSubject
                .pipe(filter(function (token) { return token != null; }), take(1), switchMap(function (token) {
                return next.handle(_this.addTokenToRequest(request, token));
            }));
        }
    };
    return AuthRequestInterceptor;
}());
export { AuthRequestInterceptor };
